import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import store from './store'
import VueElementLoading from 'vue-element-loading'
import SnackBar from './components/Common/snackBar'
import ServerError from './components/Common/500'
import ImageLoader from './components/Common/imageLoader'
import PageLoader from './components/Common/pageLoader'
import VueGtag from "vue-gtag";



import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw',
        libraries: 'places', // This is required if you use the Autocomplete plugin
    },
})

import ImageMagnifier from 'vue-image-magnifier'
Vue.use(ImageMagnifier)

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

import OwlCarousel from 'vue-owl-carousel'

// import VueSocialSharing from 'vue-social-sharing'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
Vue.component('OwlCarousel', OwlCarousel)
Vue.component('ServerError', ServerError)
Vue.component('SnackBar', SnackBar)
Vue.component('ImageLoader', ImageLoader)
Vue.component('PageLoader', PageLoader)
Vue.component('VueElementLoading', VueElementLoading)

Vue.use(VueGtag, {
    config: { id: "G-8QM2NLGCD1" }
}, router);



Vue.config.productionTip = false
window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.48.127:3700';
// Vue.prototype.baseURL = "http://192.168.48.127:3700"
// Vue.prototype.mediaURLOld = "http://192.168.48.127:3700/u/"
// Vue.prototype.mediaURL = "http://192.168.48.127:3700/wp/"

// axios.defaults.baseURL = 'http://192.168.54.133:3700';
// Vue.prototype.baseURL = "http://192.168.54.133:3700"
// Vue.prototype.mediaURLOld = "http://192.168.54.133:3700/u/"
// Vue.prototype.mediaURL = "http://192.168.54.133:3700/wp/"

// Vue.prototype.baseURL = "https://apikl06farm.leopardtechlabs.in"
// Vue.prototype.mediaURLOld = "https://apikl06farm.leopardtechlabs.in/u/"
// Vue.prototype.mediaURL = "https://apikl06farm.leopardtechlabs.in/wp/"
// axios.defaults.baseURL = 'https://apikl06farm.leopardtechlabs.in';

//  local Production
// axios.defaults.baseURL = 'https://r0z2fx1p-3700.inc1.devtunnels.ms/';
// Vue.prototype.baseURL = "https://r0z2fx1p-3700.inc1.devtunnels.ms/";
// Vue.prototype.mediaURL = "https://r0z2fx1p-3700.inc1.devtunnels.ms/wp/"
// Vue.prototype.mediaURLOld = "https://r0z2fx1p-3700.inc1.devtunnels.ms/u/"

// Local Development
// axios.defaults.baseURL = 'https://r0z2fx1p-3701.inc1.devtunnels.ms/';
// Vue.prototype.baseURL = "https://r0z2fx1p-3701.inc1.devtunnels.ms/";
// Vue.prototype.mediaURL = "https://r0z2fx1p-3701.inc1.devtunnels.ms/wp/"
// Vue.prototype.mediaURLOld = "https://r0z2fx1p-3701.inc1.devtunnels.ms/u/"

// axios.defaults.baseURL = 'https://api-dev.kl06.co.in/';
// Vue.prototype.baseURL = "https://api-dev.kl06.co.in/";
// Vue.prototype.mediaURL = "https://api-dev.kl06.co.in/wp/"
// Vue.prototype.mediaURLOld = "https://api-dev.kl06.co.in/u/"


axios.defaults.baseURL = 'https://api-dev.kl06.co.in';
Vue.prototype.baseURL = "https://api-dev.kl06.co.in/";
Vue.prototype.mediaURL = "https://api-dev.kl06.co.in/wp/"
Vue.prototype.mediaURLOld = "https://api-dev.kl06.co.in/u/"


new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')